import React from 'react';
import PropTypes from 'prop-types';
import { SearchContext } from '../../../hoc/Search';
import { LocalizationContext } from '../../../hoc/Localization';
import Category from '../Filters/Category';
import Sorting from './Sorting';
import Popover from './Popover';
import Button from '../../Button';
import Rating from '../Filters/Rating';
import Price from '../Filters/Price';
import Filters from '../Filters';
import styles from './styles.less';

const TopBar = ({ options, defaultCategories, ...props }) => {
  const { pushFilters, filtersCount, toggleFilters, filters } = React.useContext(SearchContext);
  const [freeTrial, setFreeTrial] = React.useState(filters.free_trial);
  const [rating, setRating] = React.useState(filters.rating);
  const [price, setPrice] = React.useState(filters.price);
  const { t } = React.useContext(LocalizationContext);

  return (
    <div {...props}>
      <div className={styles.topbar} key={JSON.stringify(filters)}>
        <Filters options={options} defaultCategories={defaultCategories} />

        <nav>
          <div className="desktop">
            <Category
              categories={options.categories}
              category={filters.category}
              pushFilters={pushFilters}
            />
          </div>

          <Sorting sort={filters.sort} pushFilters={pushFilters} />

          <div className="desktop">
            <Popover
              active={!!filters.rating}
              title={t('ratings')}
              content={
                <div className={styles.popover}>
                  <Rating
                    rating={rating}
                    setRating={setRating}
                  />
                  <div style={{ width: '100%' }}>
                    <a
                      className={styles.cancel}
                      onClick={() =>
                        pushFilters({
                          rating: null,
                        })}
                    >
                      {t('search.filters.cancel')}
                    </a>
                    <a
                      className={styles.apply}
                      onClick={() =>
                        pushFilters({
                          rating,
                        })}
                    >
                      {t('search.filters.apply')}
                    </a>
                  </div>
                </div>
              }
            />

            <Popover
              active={!!filters.price}
              title={t('search.price')}
              content={
                <div className={styles.popover}>
                  <Price
                    price={price}
                    freeTrial={freeTrial}
                    setPrice={setPrice}
                    setFreeTrial={setFreeTrial}
                  />

                  <a
                    className={styles.cancel}
                    onClick={() =>
                      pushFilters({
                        free_trial: null,
                        price: null,
                      })}
                  >
                    {t('search.filters.cancel')}
                  </a>
                  <a
                    className={styles.apply}
                    onClick={() =>
                      pushFilters({
                        free_trial: freeTrial,
                        price,
                      })}
                  >
                    {t('search.filters.apply')}
                  </a>
                </div>
              }
            />

            <Button
              type="secondary"
              className={filtersCount.desktop ? styles.active : null}
              onClick={() => toggleFilters()}
            >
              {t('search.more')}
            </Button>
          </div>

          <div className="mobile">
            <Button
              type="secondary"
              className={filtersCount.mobile ? styles.active : null}
              onClick={() => toggleFilters()}
            >
              {t('search.more')}
            </Button>
          </div>
        </nav>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  defaultCategories: PropTypes.array,
  options: PropTypes.object,
};

TopBar.defaultProps = {
  defaultCategories: [],
  options: {},
};

export default TopBar;
